<template>
  <div>
    <el-row class="main" type="flex" justify="center">
      <el-col :xs="{span:24,offset:0}" :sm="{span:20,offset:0}" :md="{span:16,offset:0}">
        <div id="artcle-info">
          <img id="article-banner" :src="articleIcon" />
        </div>
        <div class="article-title">
          <h2>{{articleName}}</h2>
          <el-row class="art-info d-flex align-items-center justify-content-start">
            <el-col>
              <div class="art-time">
                <i class="el-icon-time"></i>
                ：{{articleCreatTime}}
              </div>
              <div class="art-tag">
                分类：
                <el-tag size="mini">{{articleCategoryName}}</el-tag>
              </div>
            </el-col>
          </el-row>
        </div>
        <div id="artcle-content" class="markdown-body">
          <VueMarkdown :source="markdownData" v-highlight></VueMarkdown>
        </div>
        <div id="statement">
          <div class="item">{{"本文作者"}}： 孙本固</div>
          <div class="item">
            {{"原文连接"}}：
            <a :href="articleUrl" style="text-decoration:none">http://www.sunbengu.com/#/article/{{this.$route.params.id}}</a>
          </div>
          <div class="item">{{"版权声明"}}： 本博客所有文章除特别声明外,转载请注明出处!</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
export default {
  name: "f-article",
  components: {
    VueMarkdown, // 注入组件
  },
  data() {
    return {
      articleIcon: "",
      markdownData: "",
      articleName: "",
      articleCategoryName: "",
      articleCreatTime: ""
    }
  },
  computed: {
    articleUrl() {
      return "http://www.sunbengu.com/#/article/" + this.$route.params.id;
    }
  },
  created() {
    this.$store.commit("queryArticleContent", {
      id: this.$route.params.id,
      cb: (result) => {
        this.articleIcon = result.img;
        this.markdownData = result.markdownData;
        this.articleName = result.articleName;
        this.articleCategoryName = result.articleCategoryName;
        this.articleCreatTime = result.articleCreatTime;
      }
    });
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
#artcle-info {
  margin-bottom: 40px;
}

#article-banner {
  width: 100%;
  height: 100%;
}

.article-title h2 {
  margin-top: 30px;
  margin-top: 30px;
}

.article-title {
  text-align: center;
}

.art-time {
  margin-right: 0px;
  margin-top: 20px;
  margin-bottom: 30px;
  text-align: center;
  font-size: 10px;
}

.art-tag {
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 30px;
  text-align: center;
  font-size: 10px;
}

img.tag {
  width: 12px;
  height: 12px;
}

#artcle-content {
  padding: 5%;
  padding-bottom: 8%;
  margin-bottom: 40px;
}

#statement {
  border-left: 3px solid #f56c6c;
  padding: 30px;
  background-color: #ebeef5;
}

#statement .item {
  margin-bottom: 10px;
}
</style>